export interface State {
  currentIndex: number
}

export const initialState: State = {
  currentIndex: 0,
}
